<template>
  <div>
    <v-subheader>Snackbars</v-subheader>
    <v-container>
      <v-row
        justify="center"
        align="center"
      >
        <v-btn
          class="ma-2"
          color="info"
          @click="openInfoSnackBar"
        >
          INFO Snack
        </v-btn>
        <v-btn
          class="ma-2"
          color="warning"
          @click="openWarningSnackBar"
        >
          WARNING Snack
        </v-btn>
        <v-btn
          class="ma-2"
          color="error"
          @click="openErrorSnackBar"
        >
          ERROR Snack
        </v-btn>
        <v-btn
          class="ma-2"
          color="success"
          @click="openSuccessSnackBar"
        >
          SUCCESS Snack
        </v-btn>
        <v-btn
          class="ma-2"
          color="grey"
          @click="openDefaultSnackBar"
        >
          DEFAULT Snack
        </v-btn>
      </v-row>
    </v-container>
    <v-divider></v-divider>

    <v-subheader>Dialogs</v-subheader>
    <v-container>
      <v-row
        align="center"
        justify="center"
      >
        <v-btn
          class="ma-2"
          color="primary"
          @click="openAlertDialog"
        >
          Alert Dialog
        </v-btn>

        <v-btn
          class="ma-2"
          color="secondary"
          @click="openConfirmDialog"
        >
          Confirm Dialog
        </v-btn>

        <v-btn
          class="ma-2"
          color="grey"
          @click="openLoaderDialog"
        >
          Loader Dialog
        </v-btn>
      </v-row>
    </v-container>
    <v-divider></v-divider>

    <v-subheader>Loading Screen</v-subheader>
    <v-container>
      <loading-screen></loading-screen>
    </v-container>
    <v-divider></v-divider>

    <v-row
      class="ma-0"
    >
      <v-col>
        <v-card
          :draggable="true"
          @dragstart="onProcDragStart"
        >
          <v-card-text>
            Teste
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

  </div>
</template>

<script>
  import {NOTIFICATION_TYPES, NotificationOptions} from "../helpers/notify"
  import {DIALOG_TYPES, DialogOptions} from "../helpers/dialogs"
  import LoadingScreen from "../components/Helpers/LoadingScreen"

  export default {
    name: "Teste",
    components: {LoadingScreen},
    methods: {
      onProcDragStart(event) {
        event.target.style.position = 'absolute';
      },
      openInfoSnackBar() {
        this.$notify(new NotificationOptions({
          "message": "Teste Info",
          "type": NOTIFICATION_TYPES.INFO,
          "duration": 4000,
        }))
      },
      openWarningSnackBar() {
        this.$notify(new NotificationOptions({
          "message": "Teste Warning",
          "type": NOTIFICATION_TYPES.WARNING,
          "duration": 4000,
        }))
      },
      openErrorSnackBar() {
        this.$notify(new NotificationOptions({
          "message": "Teste Error",
          "type": NOTIFICATION_TYPES.ERROR,
          "duration": 4000,
        }))
      },
      openSuccessSnackBar() {
        this.$notify(new NotificationOptions({
          "message": "Teste Success",
          "type": NOTIFICATION_TYPES.SUCCESS,
          "duration": 4000,
        }))
      },
      openDefaultSnackBar() {
        this.$notify(new NotificationOptions({
          "message": "Teste Default",
          "type": NOTIFICATION_TYPES.DEFAULT,
          "duration": 4000,
        }))
      },

      openAlertDialog() {
        this.$dialog(new DialogOptions({
          "title": "Alert Dialog",
          "content": "Alert Dialog",
          "cancelText": "Custom Cancel Text",
          "persistent": true,
          "onCancel": () => {
          }
        }))
      },

      openConfirmDialog() {
        this.$dialog(new DialogOptions({
          "title": "Confirm Dialog",
          "content": "Confirm Dialog",
          "cancelText": "Custom Cancel Text",
          "confirmText": "Custom Confirm Text",
          "persistent": true,
          "onCancel": () => {
          },
          "onConfirm": () => {
          },
          "type": DIALOG_TYPES.CONFIRM
        }))
      },

      openLoaderDialog() {
        this.$dialog(new DialogOptions({
          "title": "Loader Dialog",
          "persistent": true,
          "type": DIALOG_TYPES.LOADER
        }))
      },
    },
  }
</script>

<style scoped>

</style>
